import React, { useRef } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import roadmapLeftArrow from "../assets/images/webp/roadmap-left-arrow.webp";
import roadmapRightArrow from "../assets/images/webp/roadmap-right-arrow.webp";
import { ROAD_MAP_LIST } from "./common/Helper.jsx";
import PrimaryHeading from "./custom-ui/PrimaryHeading";
import RoadmapCard from "./custom-ui/RoadmapCard";

const Roadmap = () => {
  // Reference to the Swiper instance
  const swiperRef = useRef(null);

  // Function to go to the next slide
  const goToNextSlide = () => {
    if (swiperRef.current && swiperRef.current.slideNext) {
      swiperRef.current.slideNext();
    } else {
      console.log("swiper instance is not available");
    }
  };

  // Function to go to the previous slide
  const goToPrevSlide = () => {
    if (swiperRef.current && swiperRef.current.slidePrev) {
      swiperRef.current.slidePrev();
    } else {
      console.log("swiper instance is not available");
    }
  };

  return (
    <div id="roadmap" className="2xl:max-w-[1502px] xl:max-w-[1240px] lg:px-5 md:px-8 px-5 mx-auto container 2xl:pt-48 md:pt-24 sm:pt-20 pt-[70px] 2xl:pb-24 xl:pb-16 md:pb-1 md:my-2">
      {/* Heading and navigation buttons */}
      <div className="flex sm:justify-between justify-center items-center">
        <PrimaryHeading children="Dunce Roadmap" />
        <div className="sm:flex hidden gap-5 items-center">
          {/* Previous slide button */}
          <div
            onClick={goToPrevSlide}
            className="border-[3px] xl:pointer-events-none xl:opacity-50 border-strong-blue bg-royal-blue p-3 rounded-full shadow-roadmapArrowShadow transition-all duration-300 ease-in-out hover:shadow-none hover:-translate-x-2 hover:translate-y-2 cursor-pointer"
          >
            <img
              src={roadmapLeftArrow}
              alt="roadmap-left-arrow"
              className="2xl:w-[72px] w-12 h-12 2xl:h-[72px]"
            />
          </div>
          {/* Next slide button */}
          <div
            onClick={goToNextSlide}
            className="border-[3px] xl:pointer-events-none xl:opacity-50 border-strong-blue bg-royal-blue p-3 rounded-full shadow-roadmapArrowShadow transition-all duration-300 ease-in-out hover:shadow-none hover:translate-x-2 hover:translate-y-2 cursor-pointer"
          >
            <img
              src={roadmapRightArrow}
              alt="roadmap-right-arrow"
              className="2xl:w-[72px] w-12 h-12 2xl:h-[72px]"
            />
          </div>
        </div>
      </div>

      {/* Swiper slider for the roadmap */}
      <div className="flex 2xl:pt-20 md:pt-16 sm:pt-12 pt-8 xl:gap-[90px] gap-10 relative">
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          modules={[Navigation, Pagination]}
          navigation={{
            prevEl: ".swiper-button-prev",
            nextEl: ".swiper-button-next",
          }}
          pagination={{
            dynamicBullets: false,
            clickable: true,
          }}
          slidesPerView={3}
          spaceBetween={50}
          loop={false}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1280: {
              slidesPerView: 3,
              spaceBetween: 50,
            },
            1440: {
              spaceBetween: 70,
            },
          }}
          className="swiper-container !px-0"
        >
          {/* Render roadmap cards */}
          {ROAD_MAP_LIST.map((value, index) => (
            <SwiperSlide
              className="pe-3 h-full relative z-20 lg:!pe-5"
              key={index}
            >
              <RoadmapCard index={index} value={value} />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom navigation buttons */}
        <div className="swiper-button-prev" onClick={goToPrevSlide}></div>
        <div className="swiper-button-next" onClick={goToNextSlide}></div>

        {/* Decorative dashed border */}
        <div className="border-4 border-dashed border-dark-purple w-[90%] absolute top-36 left-8 md:block hidden px-8"></div>
      </div>
    </div>
  );
};

export default Roadmap;
